import { Supplier } from "../rpc/admin/suppliers_pb";

export const DEFAULT_SUPPLIER_THUMBNAIL = 'logo192.png';

export function supplierProductLink(supplier: Supplier, sku: string): string {
    switch (supplier) {
        case Supplier.SUPPLIER_DAVIDSONS:
            return '/davidsons/' + encodeURIComponent(sku);
        case Supplier.SUPPLIER_RSR:
            return '/rsr/' + encodeURIComponent(sku);
        case Supplier.SUPPLIER_SPORTS_SOUTH:
            return '/sports-south/' + encodeURIComponent(sku);
        case Supplier.SUPPLIER_ZANDERS:
            return '/zanders/' + encodeURIComponent(sku);
    }
    console.error('unrecognized supplier: ' + supplier);
    return '';
}

export function supplierName(supplier: Supplier): string {
    switch (supplier) {
        case Supplier.SUPPLIER_DAVIDSONS:
            return 'Davidsons';
        case Supplier.SUPPLIER_RSR:
            return 'RSR';
        case Supplier.SUPPLIER_SPORTS_SOUTH:
            return 'Sports South';
        case Supplier.SUPPLIER_ZANDERS:
            return 'Zanders';
    }
    console.error('unrecognized supplier: ' + supplier);
    return '';
}
